import { Injectable, Injector } from '@angular/core';
import { SiriusServiceBase } from '@ibtech/sirius-angular-service';



@Injectable()
export class PopupService extends SiriusServiceBase {
    static popup: any;

    add(infoPopup: any) {
        PopupService.popup = infoPopup;
    }

    setModel(model: any) {
        PopupService.popup.model = model;
    }

    setParentModel(parentModel: any) {
        PopupService.popup.ParentModel = parentModel;
    }

    open() {
        PopupService.popup.open();
    }

    closeWithoutEvent() {
        PopupService.popup.closeWithoutEvent();
    }
}
